// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"UsuarioDetalle_spinnerContainer__jaFam"};